import { Unit } from '../../types';
import api from '../../utils/api';
import { omit } from 'lodash/fp';

export const updateUnit = (variables: Unit) =>
  api.put({
    url: `/unit/${variables.id}`,
    variables: omit(['id'], variables),
  });
